export function searchByBrand(mode, offsetInput) {
	const $container = mode === 'mobile' ? $('.mobile-menu-container') : $('.desktop-megaMenu-container');
	const $inputSearch = $container.find('#search-by-brand');
	const $brandListing = $container.find('.menu-brand-listing');
	const $brandCharacter = $container.find('.menu-brand-character');
	const $menuContainer = $('.slidingMenuMobile-container');
	const headerHeight = $('.siteHeader-innerWrapper .container .row').height();
	let offsetAfterScroll = 0;

	const filterBrand = function(keyword, firstload) {
		$('.menu-brand-heading').text(keyword);
		$('.menu-brand-listing li').each(function(index, el) {
			let query = keyword === '0-9' ? `^[${keyword}]` : `^${keyword}`;
			let regex = new RegExp(query, 'gi');
			let matchStr = $(el).text().match(regex);
			if (matchStr) $(el).removeClass('d-none');
			else $(el).addClass('d-none');
		});
		if (mode === 'mobile') {
			scrollSearchBoxToTop(firstload);
		}
	};

	const scrollSearchBoxToTop = function(firstload) {
		if (!firstload) {
			let offset = offsetInput - headerHeight - 10;
			let currentOffsetInput = $inputSearch.offset().top;
			if (currentOffsetInput !== offsetAfterScroll) {
				$('html, body').animate({scrollTop: 0}, 300);
				$menuContainer.animate({scrollTop: offset}, 300);
				if (offsetAfterScroll === 0) offsetAfterScroll = $menuContainer.offset().top + 10;
			}
		}
	};

	// Active A when open shop by brand
	let characterActive = $brandCharacter.find('li.active');
	let char = 'A';
	let inputVal = $inputSearch.val();
	if (inputVal && !characterActive.length) {
		filterBrand(inputVal, true);
	} else if (characterActive) {
		char = $(characterActive).find('a').text();
		filterBrand(char, true);
	}

	$brandCharacter.find('li').on('click', function() {
		$brandCharacter.find('li.active').removeClass('active');
		$(this).addClass('active');
		filterBrand($(this).text(), false);
		return false;
	});

	$inputSearch.on('keyup', function(e) {
		$brandCharacter.find('li.active').removeClass('active');
		if (!$inputSearch.val()) {
			$brandCharacter.find('li:first-child').addClass('active');
			filterBrand('A', false);
		} else {
			filterBrand($inputSearch.val(), false);
		}
	});

	$inputSearch.on('keypress', function(e) {
		if (e.which === 13) {
			e.preventDefault();
			let inputVal = $inputSearch.val().toLowerCase();
			if (inputVal) {
				let activeBrands = $brandListing.find('li:not(.d-none)');
				let firstLink = $(activeBrands[0]).find('a');
				let brand = firstLink.text().toLowerCase();
				if (activeBrands.length && inputVal === brand) {
					let href = firstLink.attr('href');
					window.location.href = href;
				}
			}
		}
	});

	$inputSearch.on('focus', function(e) {
		if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
			scrollSearchBoxToTop(false);
		}
	});

	$inputSearch.on('click', function(e) {
		e.stopPropagation();
	});
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/siteHeader/js/searchByBrand.js